export default "__VITE_ASSET__DdyK3q18__"